// // This is the js for fixing the bundle working by AI Product Bundle Builder DO NOT REMOVE

// (function () {
//   function overrideMAMBundle() {
//     const wrapper = document.getElementById(
//       'essenify-mam-bundle-wrapper'
//     );
//     const container = document.getElementById(
//       'essenify-mam-app-block'
//     );
//     const sidebar = document.getElementById(
//       'essenify-mam-sidebar'
//     );
//     const sidebarHeader = document.getElementById(
//       'essenify-mam-sidebar-header'
//     );

//     // Wait until the app block is rendered
//     if (!wrapper || !container || !sidebar || !sidebarHeader) {
//       return;
//     }

//     // Always move the sidebar into the wrapper
//     if (sidebar.parentNode !== wrapper) {
//       wrapper.appendChild(sidebar);
//     }

//     // Add our handler only once per header element
//     if (sidebarHeader.dataset.drawerOverride === 'true') {
//       return;
//     }

//     sidebarHeader.dataset.drawerOverride = 'true';

//     // Capture the click before the app's original listener
//     sidebarHeader.addEventListener(
//       'click',
//       function (event) {
//         event.preventDefault();
//         event.stopImmediatePropagation();

//         sidebar.classList.toggle('drawer-open');
//       },
//       true
//     );
//   }

//   function startObserver() {
//     // Try immediately
//     overrideMAMBundle();

//     // Watch for dynamically rendered or replaced app-block elements
//     const observer = new MutationObserver(function () {
//       overrideMAMBundle();
//     });

//     observer.observe(document.documentElement, {
//       childList: true,
//       subtree: true
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', startObserver);
//   } else {
//     startObserver();
//   }

//   // Shopify theme editor support
//   document.addEventListener('shopify:section:load', overrideMAMBundle);
// })();


 // This is the js for fixing the bundle working by AI Product Bundle Builder DO NOT REMOVE

(function () {
  function overrideMAMBundle() {
    // ============================================================
    // BYB DISCOUNT BADGE
    // Run this FIRST because BYB does not necessarily have
    // the Mix & Match DOM elements.
    // ============================================================

    addBYBDiscountBadge();

    // ============================================================
    // EXISTING MIX & MATCH LOGIC
    // ============================================================

    const wrapper = document.getElementById(
      'essenify-mam-bundle-wrapper'
    );
    const container = document.getElementById(
      'essenify-mam-app-block'
    );
    const sidebar = document.getElementById(
      'essenify-mam-sidebar'
    );
    const sidebarHeader = document.getElementById(
      'essenify-mam-sidebar-header'
    );

    // Wait until the app block is rendered
    if (!wrapper || !container || !sidebar || !sidebarHeader) {
      return;
    }

    // Always move the sidebar into the wrapper
    if (sidebar.parentNode !== wrapper) {
      wrapper.appendChild(sidebar);
    }

    // Add our handler only once per header element
    if (sidebarHeader.dataset.drawerOverride === 'true') {
      addRuleBadge();
      return;
    }

    sidebarHeader.dataset.drawerOverride = 'true';

    // Capture the click before the app's original listener
    sidebarHeader.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        sidebar.classList.toggle('drawer-open');
      },
      true
    );

    // Add the price rule badge
    addRuleBadge();
  }

  // ============================================================
  // MIX & MATCH PRICE BADGE
  // ============================================================

  function addRuleBadge() {
    const priceCols = document.querySelectorAll(
      '.essenify-mam-price-col'
    );

    priceCols.forEach(function (priceCol) {
      const priceLabel = priceCol.querySelector(
        '.essenify-mam-price-label'
      );

      if (!priceLabel) return;

      // Create the price section if it doesn't exist
      let priceSection = priceCol.querySelector(
        '.mam-price-section'
      );

      if (!priceSection) {
        priceSection = document.createElement('div');
        priceSection.className = 'mam-price-section';

        const priceValues = priceCol.querySelector(
          '.essenify-mam-price-values'
        );

        if (priceValues) {
          priceCol.insertBefore(priceSection, priceValues);
        } else {
          priceCol.appendChild(priceSection);
        }

        priceSection.appendChild(priceLabel);
      }

      // Create the badge if it doesn't exist
      let badge = priceSection.querySelector(
        '.essenify-mam-rule-percentage'
      );

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'essenify-mam-rule-percentage';
        priceSection.appendChild(badge);
      }

      function setBadgeText(text) {
        if (badge.textContent !== text) {
          badge.textContent = text;
        }
      }

      function parsePrice(element) {
        if (!element) return NaN;

        const text = element.textContent
          .replace(/,/g, '')
          .replace(/[^\d.-]/g, '')
          .trim();

        if (!text || !/\d/.test(text)) {
          return NaN;
        }

        return Number(text);
      }

      function updateDiscountBadge() {
        const originalPriceElement = priceCol.querySelector(
          '.essenify-mam-original-price'
        );

        const finalPriceElement = priceCol.querySelector(
          '.essenify-mam-price-val'
        );

        if (!originalPriceElement || !finalPriceElement) {
          setBadgeText('');
          return;
        }

        const originalPrice = parsePrice(
          originalPriceElement
        );

        const finalPrice = parsePrice(
          finalPriceElement
        );

        if (
          !Number.isFinite(originalPrice) ||
          !Number.isFinite(finalPrice) ||
          originalPrice <= 0 ||
          finalPrice < 0 ||
          finalPrice >= originalPrice
        ) {
          setBadgeText('');
          return;
        }

        const discountPercentage = Math.round(
          ((originalPrice - finalPrice) / originalPrice) * 100
        );

        setBadgeText(`(${discountPercentage}% off)`);
      }

      updateDiscountBadge();
    });
  }

  // ============================================================
  // BYB DISCOUNT BADGE
  // ============================================================

  function addBYBDiscountBadge() {
    // Remove unwanted &nbsp;&nbsp; spacing from BYB
    if (window.matchMedia('(max-width: 749px)').matches) {
      document
        .querySelectorAll('#page__Bundle-child-product .child-content')
        .forEach(function (childContent) {
          // Remove whitespace between discounted and original price
          const discountPrice = childContent.querySelector(
            '.child-prod-dis-prices'
          );

          if (
            discountPrice &&
            discountPrice.nextSibling?.nodeType === Node.TEXT_NODE
          ) {
            discountPrice.nextSibling.remove();
          }

          // Remove whitespace after currency
          childContent
            .querySelectorAll('.page-currency')
            .forEach(function (currencyElement) {
              if (
                currencyElement.nextSibling?.nodeType === Node.TEXT_NODE &&
                /^\s*$/.test(currencyElement.nextSibling.textContent)
              ) {
                currencyElement.nextSibling.remove();
              }
            });
        });
    }

    const originalPriceElement = document.getElementById(
      'totalOriginalPrice'
    );

    const discountPriceElement = document.getElementById(
      'totalDiscountPrice'
    );

    // BYB price elements may not exist yet
    if (!originalPriceElement || !discountPriceElement) {
      return;
    }

    const priceContainer =
      originalPriceElement.parentElement;

    if (!priceContainer) {
      return;
    }

    // Find existing badge
    let discountBadge = priceContainer.querySelector(
      '.byb-discount-percentage'
    );

    // Create badge if it doesn't exist
    if (!discountBadge) {
      discountBadge = document.createElement('span');

      discountBadge.className =
        'byb-discount-percentage';

      originalPriceElement.insertAdjacentElement(
        'afterend',
        discountBadge
      );
    }

    function parsePrice(element) {
      if (!element) return NaN;

      const text = element.textContent
        .replace(/,/g, '')
        .replace(/[^\d.-]/g, '')
        .trim();

      if (!text || !/\d/.test(text)) {
        return NaN;
      }

      return Number(text);
    }

    const originalPrice = parsePrice(
      originalPriceElement
    );

    const discountPrice = parsePrice(
      discountPriceElement
    );

    // Validate prices
    if (
      !Number.isFinite(originalPrice) ||
      !Number.isFinite(discountPrice) ||
      originalPrice <= 0 ||
      discountPrice < 0 ||
      discountPrice >= originalPrice
    ) {
      if (discountBadge.textContent !== '') {
        discountBadge.textContent = '';
      }

      return;
    }

    const discountPercentage = Math.round(
      ((originalPrice - discountPrice) / originalPrice) * 100
    );

    const badgeText =
      `(${discountPercentage}% off)`;

    if (discountBadge.textContent !== badgeText) {
      discountBadge.textContent = badgeText;
    }
  }

  function startObserver() {
    // Try immediately
    overrideMAMBundle();

    // One observer handles dynamically rendered content
    const observer = new MutationObserver(function () {
      overrideMAMBundle();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );
  } else {
    startObserver();
  }

  // Shopify theme editor support
  document.addEventListener(
    'shopify:section:load',
    overrideMAMBundle
  );
})();
